<div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="card bg-dark my-5">
          <div class="card-body">
            <h2 class="card-title text-center text-white py-3">{{ title }}</h2>
            <ul class="text-center list-inline py-3">
              <li class="list-inline-item">
                <a routerLink="/game" class="btn btn-info">Start</a>
                  </li>
              <li class="list-inline-item">
                <a routerLink="/scores" class="btn btn-info">Score</a>
                  </li>
              <li class="list-inline-item">
                <a routerLink="/comments" class="btn btn-info">Comments</a>
                  </li>
              <li class="list-inline-item">
                <a routerLink="/addrating" class="btn btn-info">Rate</a>
                  </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>